import { Common } from "../Components/Canvas";

export default class History {
  constructor() {
    this.history_ctx = Common.history_ctx;
    this.historyTest = [];
    this.backgrounds = [];
    this.ctx = Common.main_ctx;
    this.addListeners = this.addListeners.bind(this);
  }

  addToHistoryTest = () => {
    this.historyTest.push(Common.history_canvas.toDataURL());
  };

  addBgToHistory = () => {
    this.historyTest.push(++Common.background_ID);

    this.redrawHistory();
  };

  undo = () => {
    // don't allow to remove default painting;
    if (this.historyTest.length === 2) return;

    let lastDrawing = this.historyTest.pop();

    // remove background from backgrounds array, and update the background in history array;
    if (typeof lastDrawing === "number") {
      this.backgrounds.pop();
      this.historyTest[1] = this.backgrounds[this.backgrounds.length - 1];
    }

    this.redrawHistory();
  };

  redrawHistory = () => {
    this.history_ctx.clearRect(0, 0, Common.canvas_width, Common.canvas_height);

    // select from history only default, background and last drawing;
    let threeMainDrawings = [this.historyTest[0], this.historyTest[1]];

    // set the last drawing;
    if (Number.isInteger(this.historyTest[this.historyTest.length - 1])) {
      // this if is for when first drawing is a background, because the third element in history is background;
      if (this.historyTest.length <= 3) {
        threeMainDrawings[2] = this.historyTest[0];
      } else {
        let counter = 1;
        // if multiple BG changes in a row, get the last actual drawing;
        while (
          Number.isInteger(this.historyTest[this.historyTest.length - counter])
        ) {
          counter++;
        }
        threeMainDrawings[2] = this.historyTest[
          this.historyTest.length - counter
        ];
      }
    } else {
      threeMainDrawings[2] = this.historyTest[this.historyTest.length - 1];
    }

    let historyImage = new Image();

    historyImage.src = threeMainDrawings[2];
    historyImage.onload = () => {
      this.history_ctx.drawImage(
        historyImage,
        0,
        0,
        Common.canvas_width,
        Common.canvas_height
      );
    };

    const drawHistory = (mainDrawings, callback) => {
      let drawings = {};
      let loadedDrawing = 0;
      let numberDrawings = 3;
      // get number of history

      for (let a = 0; a < numberDrawings; a++) {
        drawings[a] = new Image();
        drawings[a].onload = function () {
          if (++loadedDrawing >= numberDrawings) {
            callback(drawings);
          }
        };
        drawings[a].src = mainDrawings[a];
      }
    };

    drawHistory(threeMainDrawings, (drawings) => {
      this.ctx.clearRect(0, 0, Common.canvas_width, Common.canvas_height);

      for (let drawing in drawings) {
        this.ctx.drawImage(
          drawings[drawing],
          0,
          0,
          Common.canvas_width,
          Common.canvas_height
        );
      }
    });
  };

  cleanTest = () => {
    this.backgrounds = [];
    this.backgrounds = [this.historyTest[0]];
    this.historyTest.length = 1;
    Common.background_ID = 0;
    this.historyTest.push(this.historyTest[0]);

    this.history_ctx.clearRect(0, 0, Common.canvas_width, Common.canvas_height);
    this.ctx.clearRect(0, 0, Common.canvas_width, Common.canvas_height);

    // this.addToHistoryTest();
    // this.addToHistoryTest();
  };

  addListeners = () => {
    let undoButton = document.querySelector(".undo_button");

    undoButton.addEventListener("click", this.undo);
  };

  // -------
  // addListeners = () => {
  //   let undoButton = document.querySelector(".undo_button");

  //   undoButton.addEventListener("click", this.drawHistory);
  // };

  // addToHistory = () => {
  //   this.history.push(Common.main_canvas.toDataURL());
  // };

  // drawHistory = () => {
  //   // don't allow to remove default painting;
  //   if (this.history.length === 1) return;

  //   let image = new Image();

  //   this.history.pop();
  //   image.src = this.history.slice(-1)[0];
  //   image.onload = () => {
  //     this.ctx.clearRect(0, 0, Common.canvas_width, Common.canvas_height);
  //     this.ctx.drawImage(image, 0, 0);
  //   };
  // };

  // clean = () => {
  //   this.history = [];

  //   this.ctx.clearRect(0, 0, Common.canvas_width, Common.canvas_height);
  //   Common.bg_ctx.clearRect(0, 0, Common.canvas_width, Common.canvas_height);

  //   this.addToHistory();
  // };
}
